export const USER_LOGIN_ROUTE = '/api/auth/login';
export const USER_LOGOUT_ROUTE = '/api/auth/logout';
export const USER_CHANGE_ROUTE = '/api/auth/change';

export const USER_CHANGE_AGREEMENT_ROUTE = '/lk/user/change-agreement';

// Policy
export const POLICY_PAGE_LINK = '/policy/app';
export const PATH_BUNDLES_LINK_CITY = '/bundles';
export const PATH_BUNDLES_LINK_VILLAGE = '/bundles/village';
export const PATH_INTERNET_LINK_CITY = '/internet';
